import { Component, DestroyRef, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { LayoutService } from '../../../../../../../../@vex/services/layout.service';
import { BillingUserRole, UserRole } from '@eadsysteme/billingclient-v1';
import { SessionService } from '../../../../../../../services/session.service';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'ara-add-user-role-dialog',
	imports: [
		ReactiveFormsModule,
		FormsModule,
		MatButton,
		MatDialogActions,
		MatDialogContent,
		MatDialogTitle,
		MatFormField,
		MatIcon,
		MatLabel,
		MatOption,
		MatSelect,
		TranslocoDirective,
		MatInput,
		MatError,
		MatCheckbox,
		CdkDragHandle,
		CdkDrag,
	],
	templateUrl: './add-user-role-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './add-user-role-dialog.component.scss',
})
export class AddUserRoleDialogComponent {
	protected layoutService = inject(LayoutService);
	dialogRef = inject<MatDialogRef<AddUserRoleDialogComponent>>(MatDialogRef);
	private sessionService = inject(SessionService);
	protected formBuilder = inject(FormBuilder);

	private destroyRef: DestroyRef = inject(DestroyRef);
	protected availableUserRoleTypes: WritableSignal<BillingUserRole[]> = signal([]);
	userRoleFormGroup: FormGroup;

	constructor() {
		const billing = inject(MAT_DIALOG_DATA);

		this.availableUserRoleTypes.set(billing.availableUserRoleTypes);
		this.createForm();
	}

	private createForm() {
		this.userRoleFormGroup = this.formBuilder.group(
			{
				name: [{ value: '', disabled: false }, Validators.pattern(new RegExp(/^[\p{Letter})0-9\-_\/\(\)., ]{0,100}$/u))],
				userRoleType: [{ value: null, disabled: false }, Validators.required],
				vacancyPossible: [{ value: false, disabled: false }],
			},
			{
				validators: [],
			}
		);

		this.userRoleFormGroup.markAllAsTouched();
	}

	close(toSave: boolean) {
		if (!toSave) {
			this.dialogRef.close();
			return;
		}
		const userRole: UserRole = {
			name: this.userRoleFormGroup.get('name').value,
			userRoleType: this.userRoleFormGroup.get('userRoleType').value,
			vacancyPossible: this.userRoleFormGroup.get('vacancyPossible').value,
		};
		this.dialogRef.close(userRole);
	}
}
